import { React, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
// import '../App.css';

const MyInfo = () => {
       const axiosPrivate = useAxiosPrivate();
       const navigateto = useNavigate();
       const [myInfo, setMyInfo] = useState({
              name: '',
              username: '',
              email: '',
              mobile: '',
              zipcode: '',
              address: '',
              detailAddress: '',
              userType: '',
              isTeacher: '',
              premiumExpireDate: '',
              birthYear: '',
       });

       useEffect(() => {
              const controller = new AbortController();

              const fetchMyInfo = async () => {
                     try {
                            const response = await axiosPrivate.get('/user/my/info', {signal: controller.signal});
                            response.data && setMyInfo(prevState => ({
                                   ...prevState,
                                   name: response.data.name,
                                   username: response.data.username,
                                   email: response.data.email,
                                   mobile: response.data.mobile,
                                   zipcode: response.data.zipcode,
                                   address: response.data.address,
                                   detailAddress: response.data.detailAddress,
                                   userType: response.data.userType,
                                   isTeacher: response.data.isTeacher,
                                   premiumExpireDate: response.data.premiumExpireDate,
                                   birthYear: response.data.birthYear
                            }));
                     } catch (e) {
                            console.log(e);
                     }
              }

              fetchMyInfo();

              return () => controller.abort();
       },[]);

       return(
              <div className="vertical-flex-container-1">
                     <div className="position-center-box-2-1">
                            <h2 style={{marginBottom: "25px"}}>{myInfo.name}님의 회원정보</h2>
                            <div className='info-row'>
                                   <span style={styles.label}>이메일</span>
                                   <span style={styles.value}>{myInfo.email}</span>
                            </div>
                            <div className='info-row'>
                                   <span style={styles.label}>전화번호</span>
                                   <span style={styles.value}>{myInfo.mobile}</span>
                            </div>
                            <div className='info-row'>
                                   <span style={styles.label}>주소</span>
                                   <div style={styles.value}>
                                          <span>({myInfo.zipcode})</span>
                                          <span> {myInfo.address}</span>
                                          <span> {myInfo.detailAddress}</span>
                                   </div>
                            </div>
                            <div className='info-row'>
                                   <span style={styles.label}>출생연도</span>
                                   <span style={styles.value}>{myInfo.birthYear}년</span>
                            </div>
                            <div className='info-row'>
                                   <span style={styles.label}>일반/유료회원</span>
                                   <span style={styles.value}>{myInfo.userType}</span>
                            </div>
                            {myInfo.userType === "유료회원" 
                                   ? <div className='info-row'>
                                          <span style={styles.label}>유료정보이용 만료일</span>
                                          <span style={styles.value}>{myInfo.premiumExpireDate}</span>
                                   </div>
                                   : <span></span>
                            }
                            <div className="horizontal-flex-container">
                                   <button 
                                          className='button'
                                          onClick={() => myInfo.isTeacher ? navigateto("/teacher/myinfo/update/") : navigateto("/student/myinfo/update/")}
                                   >
                                          회원정보 수정
                                   </button>
                                   <button 
                                          className='button'
                                          onClick={() => navigateto("/payment/1")}
                                   >
                                          유료사용권 구매
                                   </button>
                            </div>
                     </div>
              </div>
       );

}

const styles = {
       label: {
              fontWeight: 'bold',
              marginRight: '10px',
       },
       value: {
              textAlign: 'right',
              flex: 1,
       },
};

export default MyInfo;